import { useMutation, useQueryClient } from 'react-query';
import request from '../../../helpers/request';
import useFilesQuery, { key as keyWorkerFiles } from './useFilesQuery';
import { useHistory } from 'react-router-dom';

const onLoadFromHousingStock = async (value) => {
  return await request.post(
    '/Receivable/load_from_housing_stock',
    value,
    'При загрузке ЛС из ЖФ произошла ошибка',
    'Error'
  );
};

const useLoadFromHousingStock = () => {
  const queryClient = useQueryClient();
  const history = useHistory();

  const { refetch } = useFilesQuery();

  return useMutation(onLoadFromHousingStock, {
    onSuccess: async (data, { companyId }) => {
      if (data === 'Error') return;

      queryClient.invalidateQueries(keyWorkerFiles(companyId));

      const result = await refetch();

      const freshData = result.data;

      if (freshData?.[0]?.fileId) {
        history.push({
          pathname: `/Debts/file/${freshData[0].fileId}`,
          search: `?companyId=${companyId}`,
        });

        return;
      }

      history.push({
        pathname: `/Debts`,
        search: `?companyId=${companyId}`,
      });
    },
  });
};

export default useLoadFromHousingStock;
